@if (globalRuleInformations) {
<div class="globalrule-container">
    <div class="title">
        <fa-icon [icon]="faAngleRight"></fa-icon>
        <span>{{ 'GlobalRule.Title' | translate }} {{ globalRuleInformations.id ? '"' + globalRuleInformations.id + '"' : '' }}</span>
    </div>

    <div class="content">
        @if (globalRuleInformations !== undefined) {
        <form [formGroup]="globalRuleForm" (ngSubmit)="onSubmit()">
            <div class="form-content">
                <mat-card appearance="outlined" class="box default-card">
                    <mat-card-content>
                        <div class="check-form-field">
                            <mat-checkbox formControlName="enabled">{{ 'GlobalRule.EnabledPlaceholder' | translate }}</mat-checkbox>
                        </div>
                        <div>
                            <mat-form-field>
                                <mat-label>{{ 'GlobalRule.RingStatePlaceholder' | translate }}</mat-label>
                                <mat-select formControlName="ringState">
                                    @for (state of ringStates; track state) {
                                    <mat-option [value]="state">
                                        {{ 'EnumRingStates.' + state | translate }}
                                    </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div>
                            <mat-form-field>
                                <mat-label>{{ 'GlobalRule.RingSecondsPlaceholder' | translate }}</mat-label>
                                <mat-select formControlName="ringSeconds">
                                    <mat-option [value]="5">5</mat-option>
                                    <mat-option [value]="10">10</mat-option>
                                    <mat-option [value]="15">15</mat-option>
                                    <mat-option [value]="20">20</mat-option>
                                    <mat-option [value]="25">25</mat-option>
                                    <mat-option [value]="30">30</mat-option>
                                    <mat-option [value]="35">35</mat-option>
                                    <mat-option [value]="40">40</mat-option>
                                    <mat-option [value]="45">45</mat-option>
                                    <mat-option [value]="60">60</mat-option>
                                    <mat-option [value]="90">90</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div>
                            <mat-form-field>
                                <mat-label>{{ 'GlobalRule.TargetTypePlaceholder' | translate }}</mat-label>
                                <mat-select formControlName="targetType" (valueChange)="targetTypeChange($event)">
                                    @for (target of targetTypes; track target) {
                                    <mat-option [value]="target">
                                        {{ 'EnumRuleTargetTypes.' + target | translate }}
                                    </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                        @if (globalRuleForm.get('targetType').value === ruleTargetTypes.external) {
                        <div>
                            <mat-form-field>
                                <mat-label>{{ 'GlobalRule.TargetPlaceholder' | translate }}</mat-label>
                                <input matInput formControlName="target" autocomplete="off" />
                            </mat-form-field>
                        </div>
                        } @if (globalRuleForm.get('targetType').value === ruleTargetTypes.extension) {
                        <div>
                            <mat-form-field style="width: 210px">
                                <mat-label>{{ 'GlobalRule.TargetPlaceholder' | translate }}</mat-label>
                                <input type="text" matInput [matAutocomplete]="auto" formControlName="extensionTarget" />
                                <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayExtension" (optionSelected)="extensionTargetChange($event)">
                                    @for (target of extensionTargetOptions | async; track target) {
                                    <mat-option [value]="target">
                                        {{ target | extensionDisplay }}
                                    </mat-option>
                                    }
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>
                        } @if (globalRuleForm.get('targetType').value === ruleTargetTypes.service) {
                        <div>
                            <mat-form-field style="width: 210px">
                                <mat-label>{{ 'GlobalRule.TargetPlaceholder' | translate }}</mat-label>
                                <input type="text" matInput [matAutocomplete]="auto" formControlName="serviceTarget" />
                                <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayExtension" (optionSelected)="serviceTargetChange($event)">
                                    @for (target of serviceTargetOptions | async; track target) {
                                    <mat-option [value]="target">
                                        {{ target.name }}
                                    </mat-option>
                                    }
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>
                        }
                        <div>
                            <mat-form-field>
                                <mat-label>{{ 'GlobalRule.CalendarPlaceholder' | translate }}</mat-label>
                                <mat-select formControlName="calendarId">
                                    @for (calendar of calendars; track calendar) {
                                    <mat-option [value]="calendar.id">
                                        {{ calendar.name }}
                                    </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
            <div class="save-button">
                <button mat-stroked-button type="button" color="accent" routerLink="/globalrules">{{ 'GlobalRule.CancelButton' | translate }}</button>
                <button mat-raised-button color="accent" [disabled]="!globalRuleForm.valid" type="submit">{{ 'GlobalRule.SubmitButton' | translate }}</button>
            </div>
        </form>
        }
    </div>
</div>
}
